import styled from 'styled-components/macro'

/**
 * styled-component wrapper for an input group:
 *
 * - `<Label />`
 * - `<TextInput />`
 * - `<InfoMessage />`
 */
export const InputGroup = styled.div<{
  $fullWidth?: boolean
  $marginBottom?: string
}>`
  display: inline-flex;
  flex-flow: column nowrap;
  margin-bottom: ${({ $marginBottom }) => $marginBottom || '1rem'};
  ${({ $fullWidth }) =>
    $fullWidth
      ? `
    width: 100%;
  `
      : `
    width: inherit;
  `}
`
